import { baseApi } from "../baseApi";
import {
  WellnessV2ConfigResponse,
  WellnessV2DashboardSummaryResponse,
  WellnessV2HistoryResponse,
  WellnessV2SubmitRequest,
  WellnessV2SubmitResponse,
  WellnessV2TodaySessionResponse,
} from "./type";

export const wellnessV2Api = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getWellnessV2Config: build.query<WellnessV2ConfigResponse, void>({
      query: () => ({
        url: "/wellness-v2/config",
        method: "GET",
      }),
      providesTags: ["WellnessV2"],
    }),
    getWellnessV2Today: build.query<WellnessV2TodaySessionResponse, void>({
      query: () => ({
        url: "/wellness-v2/today",
        method: "GET",
      }),
      providesTags: ["WellnessV2", "WellnessV2Dashboard"],
    }),
    submitWellnessV2Checkin: build.mutation<
      WellnessV2SubmitResponse,
      WellnessV2SubmitRequest
    >({
      query: (body) => ({
        url: "/wellness-v2/checkins",
        method: "POST",
        body,
      }),
      invalidatesTags: ["WellnessV2", "WellnessV2History", "WellnessV2Dashboard", "Dashboard"],
    }),
    getWellnessV2History: build.query<
      WellnessV2HistoryResponse,
      { page?: number; limit?: number }
    >({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: "/wellness-v2/history",
        method: "GET",
        params: { page, limit },
      }),
      providesTags: ["WellnessV2History"],
    }),
    getWellnessV2DashboardSummary: build.query<
      WellnessV2DashboardSummaryResponse,
      void
    >({
      query: () => ({
        url: "/wellness-v2/dashboard-summary",
        method: "GET",
      }),
      providesTags: ["WellnessV2Dashboard"],
    }),
  }),
});

export const {
  useGetWellnessV2ConfigQuery,
  useGetWellnessV2TodayQuery,
  useSubmitWellnessV2CheckinMutation,
  useGetWellnessV2HistoryQuery,
  useGetWellnessV2DashboardSummaryQuery,
} = wellnessV2Api;
